const getTokenLogoURL = (address: string) =>
  `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${address}/logo.png`

export default getTokenLogoURL
